import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'extend-canvas' as const;

const sourceImageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('url'),
    url: z.string().describe('URL of the source image'),
  }),
  z.object({
    type: z.literal('base64'),
    base64: z.string().describe('Base64-encoded image data'),
    mimeType: z
      .string()
      .describe('MIME type of the image (e.g. image/png, image/jpeg)'),
  }),
]);

const argumentZod = z.object({
  sourceImage: sourceImageSchema.describe('The source image to extend'),
  targetWidth: z
    .number()
    .int()
    .min(1)
    .describe('Target width in pixels for the extended canvas'),
  targetHeight: z
    .number()
    .int()
    .min(1)
    .describe('Target height in pixels for the extended canvas'),
  prompt: z
    .string()
    .optional()
    .describe(
      'Optional prompt describing what to generate in the extended area. If omitted, the AI will infer from context.'
    ),
});

export const extendCanvasManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Extend canvas',
  prettyStatus: {
    executed: 'Extended canvas',
    executing: 'Extending canvas',
    failed: 'Failed to extend canvas',
  },
  llmTool: {
    name: toolName,
    description:
      'Extends (outpaints) an image to a larger canvas size. The original image is preserved and new content is generated to fill the extended area, matching the style and context of the original.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteFile', action: 'manage'}],
  confirmBeforeExecuting: false,
  timeout: 120_000,
});
